<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcesso",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisar",
      @limpar="clear",
      :configuracaoFiltro="configuracaoFiltro",
      :filtroRapido="filtroRapido"
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  app-listagem(
    :has-refresh-button="true",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items"
    :totalElements="totalElements",
    :pagina="filtro.pagina",
    :hasFiltroRapido="false",
    :filtro="filtro",
    :hasActionButton="true",
    typeActionButton="success",
    nameActionButton="Cadastrar",
    sizeActionButton="medium",
    @click="goToNewCadastro"
    @atualizarFiltro="atualizarFiltro"
    @updateListagem="refresh",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    :showButtonRegerar="showButtonRegerar()"
  )
  span.padding-left(v-if="showButtonOrdemServico") {{ 'Processos Selecionados: ' + idsProcessos.length }}
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'
import moment from 'moment'
import AppListagem from '@/components/AppListagem.vue'
import Filtro from './Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const { filtro, showFiltroTipoMultiplo, isGcgCgir } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('./' + process.env.ESTADO + '/BaseFiltro').default

export default {

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro,
    AppNotificacao
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('CADASTROS_EM_ANDAMENTO_UC'),
      items: [],
      totalElements: 0,
      processosSelecionados: [],
      disabledAnalisar: false,
      showModalVisualizarProcesso: false,
      idProcesso: null,
      numeroProcesso: null,
      tipoProcesso: null,
      setorSelecionado: null,
      protocolo: null,
      configuracaoFiltro: {
        filtroSituacao: filtro?.filtroSituacao?.CAIXA_ENTRADA || [],
        filtroResponsavel: filtro?.filtroResponsavel?.CAIXA_ENTRADA || [],
        filtroReceita: filtro?.filtroReceita?.CAIXA_ENTRADA || [],
        filtroMunicipio: filtro?.filtroMunicipio?.CAIXA_ENTRADA || [],
        filtroOrdemServico: filtro?.filtroOrdemServico?.CAIXA_ENTRADA || [],
        filtroFuncao: filtro?.filtroFuncao?.CAIXA_ENTRADA || [],
        filtroDataVencimento: filtro?.filtroDataVencimento?.CAIXA_ENTRADA || [],
        filtroRua: filtro?.filtroRua?.CAIXA_ENTRADA || [],
        filtroBairro: filtro?.filtroBairro?.CAIXA_ENTRADA || [],
        filtroRemessa: filtro?.filtroRemessa?.CAIXA_ENTRADA || [],
        filtroQuadra: filtro?.filtroQuadra?.CAIXA_ENTRADA || [],
        filtroClausulaResolutiva: filtro?.filtroClausulaResolutiva?.CAIXA_ENTRADA || [],
        filtroVistoriador: filtro?.filtroVistoriador?.CAIXA_ENTRADA || [],
        filtroPerfil: filtro?.filtroPerfil?.CAIXA_ENTRADA || []
      },
      colunas: [
        { id: 1, titulo: 'Situação', propriedade: 'status', ordem: 1, acoes: [], formatter: this.formatStatus },
        { id: 5, titulo: 'CNUC', propriedade: 'cnuc', ordem: 1, acoes: [] },
        { id: 6, titulo: 'Nome da UC', propriedade: 'gleba', ordem: 1, acoes: [] },
        { id: 7, titulo: 'Categoria', propriedade: 'categoria', ordem: 1, acoes: [], formatter: this.formatCategoria },
        { id: 2, titulo: 'Data Cadastro', propriedade: 'datacadastro', ordem: 2, acoes: [], formatter: ({datacadastro}) => this.formatTimestamp(datacadastro) },
        { id: 3, titulo: 'Data Alteração', propriedade: 'dataalteracao', ordem: 3, acoes: [], formatter: ({dataalteracao}) => this.formatTimestamp(dataalteracao) },
        { id: 4, titulo: 'Protocolo', propriedade: 'protocolo', ordem: 3, acoes: [] },
        {
          id: 4, titulo: 'Ações', propriedade: 'tipo', ordem: 5, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Editar', icone: 'fa-edit', codigo: 'EDITAR_CADASTRO', ordem: 1 },
            { id: 2, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcessoUc }
          ]
        }
      ],
      usuario: null,
      filtroRapido: null,
      showFiltroTipoMultiplo
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    }
  },
  async created () {
    this.usuario = await this.usuarioLogado
  },
  computed: {
    ...mapGetters({
      usuarioLogado: 'auth/usuarioLogado'
    }),
    ...mapState({
      listaProcessosAuxiliar: state => state.ordemServico.listaProcessosAuxiliar
    }),
    showButtonOrdemServico () {
      return false
    }
  },

  methods: {

    ...mapActions({
      ordemServicoClear: 'ordemServico/clear',
      setListaProcessoAuxiliar: 'ordemServico/setListaProcessoAuxiliar',
      retornarSetor: 'processo/retornarSetor',
      setProcessoSelecionados: 'ordemServico/setProcessoSelecionados',
      getPvtnAtivo: 'vtn/getPvtnAtivo',
      checkAnaliseManual: 'processo/checkAnaliseManual',
      getProcessoByProtocolo: 'processos/getProcessoByProtocolo',
      getDadosProcesso: 'processos/getDadosProcessoByProtocolo',
      iniciarValidaoManual: 'processo/iniciarValidaoManual',
      exportarCsvAnalise: 'processo/exportarCsvAnalise',
      tramitarComAcao: 'processo/tramitarComAcao',
      regerar: 'filaAnaliseAutomatizada/regerar',
      retirarProcessoDaFila: 'filaAnaliseAutomatizada/retirarProcessoDaFila',
      cadastroUcNovo: 'cadastroUc/cadastroUcNovo',
      cadastroUcById: 'cadastroUc/cadastroUcById'
    }),
    goToNewCadastro () {
      this.cadastroUcNovo()
        .then((id) => {
          this.$router.push({
            name: 'cadastro-uc',
            params: {
              id: id
            }
          })
        })
    },

    showButtonRegerar () {
      return isGcgCgir(this.usuario?.perfilSelecionado?.setor?.codigo)
    },

    formatStatus (item) {
      switch (item.status) {
        case 'EM_ANDAMENTO':
          return 'Em Andamento'
        case 'EM_RETIFICACAO':
          return 'Em Retificação'
        default:
          return 'Unknown'
      }
    },

    formatCategoria (item) {
      if (!item.categoria) {
        return '-'
      }
      return item.categoria === 'ProtecaoIntegral' ? 'Proteção Integral' : 'Uso Sustentavel'
    },

    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario?.perfilSelecionado?.codigo)
    },
    async VISUALIZAR_PROCESSO (_this, { item }) {
      const { id, numero } = await this.getDadosProcesso(item.protocolo)
      this.idProcesso = id
      this.numeroProcesso = numero
      this.tipoProcesso = 'UC'
      this.protocolo = item.protocolo
      this.showModalVisualizarProcesso = true
    },
    EDITAR_CADASTRO (_this, { item }) {
      const idCadastro = item.id
      this.$router.push({
        name: 'cadastro-uc',
        params: { id: idCadastro }
      })
    },
    atualizarFiltro (novoFiltro) {
      this.filtro = {
        ...this.filtro,
        ...novoFiltro
      }

      this.filtroRapido = novoFiltro
    },
    formatTimestamp (timestamp) {
      return timestamp ? moment(timestamp).format('DD/MM/YYYY') : '-'
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
.padding-left {
  padding-left: 25px;
}
@media (max-width: 780px) {
  .card-container {
    margin: 0 0 15px 0 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/listagem/CaixaCadastrosEmAndamentoListagemUc.vue